import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)")({
  // Marketing / legal pages stay SSR (and are statically prerendered at build).
  ssr: true,
  component: RouteComponent,
});

/**
 * Public pages render their own chrome (the landing page ships a full marketing
 * header and footer), so this layout is a thin passthrough.
 */
function RouteComponent() {
  return <Outlet />;
}
